const translations = {
  en: {
    nav_home: 'Home',
    nav_about: 'Who We Are',
    nav_destinations: 'Colombia',
    nav_experiences: 'Experiences',
    nav_contact: 'Contact',
    hero_tagline: 'DMC in Colombia',
    hero_cta: 'Discover Colombia',
    who_we_are_title: 'Who We Are',
    essence_overline: 'Our Essence',
    essence_title: 'Experiences in Colombia designed to be felt, not just traveled.',
    essence_paragraph: 'We design tailor-made journeys where every detail responds to a clear intention. More than itineraries, we create moments meant to be lived in a unique way.',
    who_we_are_text_part1: 'We were born from the union of two worlds:',
    who_we_are_precision: 'precision',
    who_we_are_and: 'and',
    who_we_are_intuition: 'intuition',
    who_we_are_text_part2: '. We design journeys where structure meets',
    who_we_are_soul: 'soul',
    who_we_are_text_part3: ', creating experiences that go beyond travel. This is not tourism.',
    who_we_are_text_emphasis: 'It is a curated experience.',
    colombia_title: 'Colombia',
    colombia_intro: 'A country of contrasts, where culture, nature and luxury experiences coexist. From vibrant cities to untouched landscapes, each destination offers a different way to experience Colombia. All within short distances.',
    colombia_teaser_overline: 'Colombia',
    colombia_teaser_title: 'A country of contrasts, meant to be felt.',
    colombia_teaser_title_main: 'A country of contrasts,',
    colombia_teaser_title_italic: 'meant to be felt.',
    colombia_teaser_text: 'From vibrant cities to untouched landscapes, Colombia offers distinct ways of being lived. Discover the regions we curate with intention.',
    colombia_teaser_cta: 'Discover Colombia',
    colombia_page_overline: 'Destination',
    back_to_home: 'Back to home',
    bogota_title: 'Bogotá',
    bogota_desc: 'A vibrant capital where culture, gastronomy and history converge. Signature culinary moments and refined cultural explorations, Bogotá reveals a sophisticated and unexpected side of Colombia.',
    cartagena_title: 'Cartagena',
    cartagena_desc: 'A timeless destination where history, architecture and Caribbean charm meet. Sunset sailing along the coastline, followed by curated dining in hidden courtyards, Cartagena invites a slower, more refined way to experience Colombia.',
    medellin_title: 'Medellín',
    medellin_desc: 'A city defined by innovation, design and transformation. Exclusive urban experiences paired with curated cultural encounters, Medellín offers a modern, dynamic way to experience Colombia.',
    coffee_title: 'Coffee Region',
    coffee_desc: 'A landscape of rolling hills, lush greenery and timeless traditions. Morning rituals, slow living and deep connection to origin. A more grounded and sensory way to experience Colombia.',
    cali_title: 'Cali',
    cali_desc: 'A city where rhythm, culture and authenticity come to life. Intimate dance encounters and carefully designed cultural moments, Cali offers a vibrant, immersive way to experience Colombia.',
    map_overline: 'Sustainability',
    map_title: 'Sustainability Policy',
    map_subtitle: 'Click to discover our commitment',
    map_cta: 'Download PDF',
    map_card_overline: 'Our Map',
    map_card_title: 'Five regions, one curated experience',
    map_footer_tagline: 'Inaluna DMC - Your Door to Colombia',
    map_card_title: 'Map of Destinations',
    region_caribe: 'Caribbean',
    region_pacifico: 'Pacific',
    region_andina: 'Andean',
    region_orinoquia: 'Orinoquía',
    region_amazonia: 'Amazon',
    hover_hint: 'Hover over a region to explore',
    explore_map: 'Explore',
    highlights_suffix: 'HIGHLIGHTS',
    points_of_interest: 'Points of Interest',
    see_more: 'See More',
    highlights_title: 'Curated Highlights',
    wellness_title: 'Wellness & Spirituality Retreats',
    cultural_title: 'Private Cultural Immersions',
    nature_title: 'Luxury Nature Experiences',
    tailor_title: 'Tailor-Made Journeys',
    curated_highlight: 'Curated Highlight',
    contact_title: 'Let us design your journey',
    contact_subtitle: 'Every experience we design is unique',
    form_q1_title: 'What type of experience do you wish to design?',
    form_q1_opt1: 'I have a specific concept or program in mind',
    form_q1_opt2: 'I would like to receive a curated recommendation',
    form_q1_opt3: 'I am looking for a fully tailor-made experience',
    form_q2_title: 'What type of experience are you organizing?',
    form_q2_opt1: 'Corporate / incentive trip',
    form_q2_opt2: 'Business event or meeting',
    form_q2_opt3: 'Convention or congress',
    form_q2_opt4: 'Team building experience',
    form_q2_opt5: 'High-end private journey',
    form_q2_opt6: 'Other',
    form_q2_other_placeholder: 'Specify...',
    form_q3_title: 'Is there a specific destination or experience of interest?',
    form_q3_placeholder: 'If you have a destination in mind, share it. Otherwise, we will design a proposal aligned with your profile.',
    form_q4_title: 'When do you plan to do this trip or event?',
    form_q4_opt1: 'I have defined dates',
    form_q4_opt2: 'I am flexible (month or season)',
    form_q4_opt3: 'I am in the initial planning stage',
    form_q4_dates: 'Approximate dates',
    form_q5_title: 'How many people are part of the group?',
    form_q5_placeholder: 'Approximate number of participants',
    form_q6_title: 'How would you describe the level of experience you seek?',
    form_q6_opt1: 'Balanced: comfort and quality with optimized investment',
    form_q6_opt2: 'High-end: carefully selected experiences',
    form_q6_opt3: 'Premium: access to the best available, no compromises',
    form_q7_title: 'Are there important considerations we should take into account?',
    form_q7_guide: 'Mobility, health, dietary preferences or other relevant needs.',
    form_q7_opt1: 'Yes (detail below)',
    form_q7_opt2: 'No',
    form_q7_placeholder: 'Please detail...',
    form_q8_title: 'What is the main objective of this experience?',
    form_q8_opt1: 'Incentivize and motivate a team',
    form_q8_opt2: 'Strengthen relationships (internal or clients)',
    form_q8_opt3: 'Integration / team building',
    form_q8_opt4: 'Cultural experience or exploration',
    form_q8_opt5: 'Special celebration',
    form_q8_opt6: 'Other',
    form_q9_title: 'Additional Details',
    form_q9_subtitle: 'Tell us more about what you are looking for',
    form_q9_placeholder: 'Special interests, desired experiences, type of group, expectations or any detail that helps us design a fully aligned proposal.',
    form_q10_closing_title: 'Every experience we design is unique.',
    form_q10_closing_text: 'Our team will review your request and contact you to begin building a carefully tailored proposal. Every journey begins with a conversation.',
    form_contact_section: 'Contact Information',
    form_name: 'Full Name',
    form_company: 'Company',
    form_email: 'Corporate Email',
    form_phone: 'Phone',
    form_submit: 'Send Request',
    form_sending: 'Sending...',
    form_success: 'Thank you! We will contact you soon.',
    form_error: 'An error occurred. Please try again.',
    footer_tagline: 'Curated Experiences in Colombia',
    footer_rights: 'All rights reserved.',
    footer_follow: 'Follow Us',
    footer_email: 'Email',
    footer_phone: 'Phone',
    footer_rnt: 'RNT',
    footer_location: 'Location'
  },
  es: {
    nav_home: 'Inicio',
    nav_about: 'Quiénes Somos',
    nav_destinations: 'Colombia',
    nav_experiences: 'Experiencias',
    nav_contact: 'Contacto',
    hero_tagline: 'DMC en Colombia',
    hero_cta: 'Descubre Colombia',
    who_we_are_title: 'Quiénes Somos',
    essence_overline: 'Nuestra Esencia',
    essence_title: 'Experiencias en Colombia diseñadas para sentirse, no solo para recorrerse.',
    essence_paragraph: 'Diseñamos viajes a medida donde cada detalle responde a una intención clara. Más que itinerarios, creamos momentos pensados para vivirse de forma única.',
    who_we_are_text_part1: 'Nacimos de la unión de dos mundos:',
    who_we_are_precision: 'precisión',
    who_we_are_and: 'e',
    who_we_are_intuition: 'intuición',
    who_we_are_text_part2: '. Diseñamos viajes donde la estructura se encuentra con el',
    who_we_are_soul: 'alma',
    who_we_are_text_part3: ', creando experiencias que van más allá del turismo. Esto no es turismo.',
    who_we_are_text_emphasis: 'Es una experiencia curada.',
    colombia_title: 'Colombia',
    colombia_intro: 'Un país de contrastes, donde la cultura, la naturaleza y las experiencias de lujo coexisten. Desde ciudades vibrantes hasta paisajes vírgenes, cada destino ofrece una forma diferente de experimentar Colombia. Todo a cortas distancias.',
    colombia_teaser_overline: 'Colombia',
    colombia_teaser_title: 'Un país de contrastes, pensado para sentirse.',
    colombia_teaser_title_main: 'Un país de contrastes,',
    colombia_teaser_title_italic: 'pensado para sentirse.',
    colombia_teaser_text: 'Desde ciudades vibrantes hasta paisajes intactos, Colombia ofrece distintas formas de ser vivida. Descubre las regiones que seleccionamos con intención.',
    colombia_teaser_cta: 'Descubrir Colombia',
    colombia_page_overline: 'Destino',
    back_to_home: 'Volver al inicio',
    bogota_title: 'Bogotá',
    bogota_desc: 'Una capital vibrante donde convergen cultura, gastronomía e historia. Momentos culinarios únicos y exploraciones culturales refinadas, Bogotá revela un lado sofisticado e inesperado de Colombia.',
    cartagena_title: 'Cartagena',
    cartagena_desc: 'Un destino atemporal donde se encuentran historia, arquitectura y encanto caribeño. Navegación al atardecer por la costa, seguida de cenas curadas en patios escondidos, Cartagena invita a una forma más lenta y refinada de experimentar Colombia.',
    medellin_title: 'Medellín',
    medellin_desc: 'Una ciudad definida por la innovación, el diseño y la transformación. Experiencias urbanas exclusivas combinadas con encuentros culturales curados, Medellín ofrece una forma moderna y dinámica de experimentar Colombia.',
    coffee_title: 'Región Cafetera',
    coffee_desc: 'Un paisaje de colinas onduladas, vegetación exuberante y tradiciones atemporales. Rituales matutinos, vida lenta y conexión profunda con el origen. Una forma más arraigada y sensorial de experimentar Colombia.',
    cali_title: 'Cali',
    cali_desc: 'Una ciudad donde el ritmo, la cultura y la autenticidad cobran vida. Encuentros íntimos de baile y momentos culturales cuidadosamente diseñados, Cali ofrece una forma vibrante e inmersiva de experimentar Colombia.',
    map_overline: 'Sostenibilidad',
    map_title: 'Política de Sostenibilidad',
    map_subtitle: 'Haz clic para descubrir nuestro compromiso',
    map_cta: 'Descargar PDF',
    map_card_overline: 'Nuestro Mapa',
    map_card_title: 'Cinco regiones, una experiencia curada',
    map_footer_tagline: 'Inaluna DMC - Tu Puerta a Colombia',
    map_card_title: 'Mapa de Destinos',
    region_caribe: 'Caribe',
    region_pacifico: 'Pacífico',
    region_andina: 'Andina',
    region_orinoquia: 'Orinoquía',
    region_amazonia: 'Amazonía',
    hover_hint: 'Pasa el cursor sobre una región para explorar',
    explore_map: 'Explorar',
    highlights_suffix: 'HIGHLIGHTS',
    points_of_interest: 'Puntos de Interés',
    see_more: 'Ver Más',
    highlights_title: 'Experiencias Destacadas',
    wellness_title: 'Retiros de Bienestar y Espiritualidad',
    cultural_title: 'Inmersiones Culturales Privadas',
    nature_title: 'Experiencias de Naturaleza de Lujo',
    tailor_title: 'Viajes a Medida',
    curated_highlight: 'Experiencia Curada',
    contact_title: 'Diseñemos tu viaje',
    contact_subtitle: 'Cada experiencia que diseñamos es única',
    form_q1_title: '¿Qué tipo de experiencia deseas diseñar?',
    form_q1_opt1: 'Tengo un concepto o programa específico en mente',
    form_q1_opt2: 'Me gustaría recibir una recomendación curada',
    form_q1_opt3: 'Busco una experiencia totalmente diseñada a medida',
    form_q2_title: '¿Qué tipo de experiencia estás organizando?',
    form_q2_opt1: 'Viaje corporativo / incentivo',
    form_q2_opt2: 'Evento o reunión empresarial',
    form_q2_opt3: 'Convención o congreso',
    form_q2_opt4: 'Experiencia de team building',
    form_q2_opt5: 'Viaje privado de alto nivel',
    form_q2_opt6: 'Otro',
    form_q2_other_placeholder: 'Especifica...',
    form_q3_title: '¿Hay algún destino o experiencia de interés?',
    form_q3_placeholder: 'Si tienes algún destino en mente, compártelo. De lo contrario, diseñaremos una propuesta alineada a tu perfil.',
    form_q4_title: '¿Cuándo planeas realizar este viaje o evento?',
    form_q4_opt1: 'Tengo fechas definidas',
    form_q4_opt2: 'Soy flexible (mes o temporada)',
    form_q4_opt3: 'Estoy en etapa inicial de planeación',
    form_q4_dates: 'Fechas aproximadas',
    form_q5_title: '¿Cuántas personas forman parte del grupo?',
    form_q5_placeholder: 'Número aproximado de participantes',
    form_q6_title: '¿Cómo describirías el nivel de la experiencia que buscas?',
    form_q6_opt1: 'Equilibrado: confort y calidad con inversión optimizada',
    form_q6_opt2: 'Alto nivel: experiencias cuidadosamente seleccionadas',
    form_q6_opt3: 'Premium: acceso a lo mejor disponible, sin compromisos',
    form_q7_title: '¿Hay consideraciones importantes que debamos tener en cuenta?',
    form_q7_guide: 'Movilidad, salud, preferencias alimentarias u otras necesidades relevantes.',
    form_q7_opt1: 'Sí (detallar abajo)',
    form_q7_opt2: 'No',
    form_q7_placeholder: 'Por favor detalla...',
    form_q8_title: '¿Cuál es el objetivo principal de esta experiencia?',
    form_q8_opt1: 'Incentivar y motivar un equipo',
    form_q8_opt2: 'Fortalecer relaciones (internas o clientes)',
    form_q8_opt3: 'Integración / team building',
    form_q8_opt4: 'Experiencia cultural o exploración',
    form_q8_opt5: 'Celebración especial',
    form_q8_opt6: 'Otro',
    form_q9_title: 'Detalles Adicionales',
    form_q9_subtitle: 'Cuéntanos más sobre lo que estás buscando',
    form_q9_placeholder: 'Intereses especiales, experiencias deseadas, tipo de grupo, expectativas o cualquier detalle que nos ayude a diseñar una propuesta completamente alineada a ti.',
    form_q10_closing_title: 'Cada experiencia que diseñamos es única.',
    form_q10_closing_text: 'Nuestro equipo revisará tu solicitud y te contactará para comenzar a construir una propuesta cuidadosamente adaptada. Todo comienza con una conversación.',
    form_contact_section: 'Información de Contacto',
    form_name: 'Nombre Completo',
    form_company: 'Empresa',
    form_email: 'Email Corporativo',
    form_phone: 'Teléfono',
    form_submit: 'Enviar Solicitud',
    form_sending: 'Enviando...',
    form_success: '¡Gracias! Te contactaremos pronto.',
    form_error: 'Ocurrió un error. Por favor intenta de nuevo.',
    footer_tagline: 'Experiencias Curadas en Colombia',
    footer_rights: 'Todos los derechos reservados.',
    footer_follow: 'Síguenos',
    footer_email: 'Email',
    footer_phone: 'Teléfono',
    footer_rnt: 'RNT',
    footer_location: 'Ubicación'
  }
};

export default translations;
